export const environment = {
	appVersion: require('../../package.json').version + '-acc',
	env: 'acc',
	hmr: false,
	debug: false,
	apiUrl: 'https://test.apollo.quickrelease.aero/graphql',
	wsUrl: 'wss://test.apollo.quickrelease.aero/graphql',
	baseHelpUrl: 'https://docs.quickrelease.aero/',
	// 037: Meta Tech-Provider app + Embedded Signup configuration (public identifiers, FR-020)
	metaAppId: '1965623997471490',
	metaEsConfigId: '3176224219234765',
	production: false,
	identityPlatformUrl: 'https://identitytoolkit.googleapis.com/v1/',
	identityPlatformResetPasswordSuffix: 'accounts:sendOobCode?key=',
	identityPlatformSignInSuffix: 'accounts:signInWithPassword?key=',
	identityPlatformEmailLinkSuffix: 'accounts:signInWithEmailLink?key=',
	identityPlatformRefreshTokenSuffix: 'token?key=',
	identityPlatformApiKey: 'AIzaSyA5YwPSrpdi3Igxho_9Y4xzOb_Qrqhh_OM',
	upURL: 'https://test.up.quickrelease.aero/',
	icsUrl: 'https://calendar.quickrelease.aero/',
	waBucketUrl: 'https://storage.googleapis.com/qr-apollo-whatsapp',
	// *************** TODO ****************** needs to be removed in a later stage
	firebase: {
		apiKey: 'AIzaSyCNCUsll4dCkra_fUtDw78o5gE1LB74l0c',
		authDomain: 'qr2021-dev.firebaseapp.com',
		projectId: 'qr2021-dev',
		storageBucket: 'qr2021-dev.appspot.com',
		messagingSenderId: '897013689295',
		appId: '1:897013689295:web:d45f23fc47c023b50780ba',
		measurementId: 'G-4H6MD0ZG26',
	},
	trackingCode: 'G-ZTGDF4KN57',
	componentGuards: {
		dashboard: {
			meteo: [UserRole.Opr, UserRole.Met, UserRole.Ass, UserRole.Cre],
			flights: [UserRole.Opr, UserRole.Met, UserRole.Ass, UserRole.Cre],
			addFlights: [UserRole.Opr],
			bookings: [UserRole.Opr, UserRole.Ass],
			sms: [UserRole.Opr, UserRole.Ass],
			charts: [UserRole.Opr, UserRole.Cre],
		},
		dateCard: {
			plan: [UserRole.Opr],
		},
		flightCard: {
			edit: [UserRole.Opr, UserRole.Ass, UserRole.Met],
			checkIn: [UserRole.Opr, UserRole.Cre],
			bookings: [UserRole.Opr, UserRole.Ass],
		},
		flightList: {
			bookingsColumn: [UserRole.Opr, UserRole.Ass],
		},
		flightDetail: {
			crew: [UserRole.Opr, UserRole.Ass],
			bookings: [UserRole.Opr, UserRole.Ass],
			payments: [UserRole.Opr, UserRole.Ass],
			log: [UserRole.Opr, UserRole.Ass],
		},
		calendar: {
			event: [UserRole.Opr, UserRole.Ass],
			operator: [UserRole.Opr, UserRole.Ass, UserRole.Rep, UserRole.Met],
		},
		bookingDetail: {
			delete: [UserRole.Opr],
		},
		toolbar: {
			operator: [UserRole.Opr, UserRole.Ass],
		},
	},
	featureToggles: [
		{ featureName: 'logBooks', featureActive: true },
		{ featureName: 'api', featureActive: true },

		{ featureName: 'FlightAppApi', featureActive: true },
	],
};

import { UserRole } from 'src/app/core/graphql/generated/gen-types';
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
